<template>
  <el-dialog
    :title="'在线编程实验室 - ' + toolLabel"
    :visible.sync="dialogVisible"
    width="85%"
    top="5vh"
    :close-on-click-modal="false"
    @close="handleClose">
    <div class="coding-tool">
      <!-- Scratch 嵌入式编辑器（自托管于本域，后端 /scratch/** 提供） -->
      <div v-if="courseType == 'scratch'" class="scratch-wrap">
        <iframe
          :src="scratchUrl"
          class="scratch-iframe"
          allow="autoplay; camera; microphone"
          frameborder="0"></iframe>
        <div class="coding-tip">
          <i class="el-icon-info"></i>
          编程完成后，请将作品保存并导出为 .sb3 文件，在下方提交框中备注说明。
          <el-link type="primary" :underline="false" style="margin-left:8px" @click="openScratchTab">新标签页打开</el-link>
        </div>
        <div class="submit-area">
          <el-input type="textarea" :rows="3" v-model="scratchRemark" placeholder="作品说明（保存的作品文件名/创作思路等）"></el-input>
          <el-button size="mini" type="primary" style="margin-top:10px" @click="submitScratch">提交作品说明</el-button>
        </div>
      </div>
      <!-- Python / C++ 代码编辑器 -->
      <div v-else class="editor-wrap">
        <div class="editor-left">
          <div class="editor-toolbar">
            <span class="editor-file">{{ fileName }}</span>
            <div>
              <el-button size="mini" icon="el-icon-refresh" @click="resetCode">重置代码</el-button>
              <el-button size="mini" type="success" icon="el-icon-video-play" :loading="running" @click="runCode">运行</el-button>
            </div>
          </div>
          <textarea
            class="code-editor"
            v-model="code"
            spellcheck="false"
            @keydown.tab.prevent="insertTab"></textarea>
        </div>
        <div class="editor-right">
          <div class="output-title">运行结果</div>
          <div class="output-area">
            <div v-if="running" class="output-loading"><i class="el-icon-loading"></i> 正在编译运行...</div>
            <pre v-else class="output-content">{{ output || '点击"运行"按钮执行代码' }}</pre>
          </div>
          <div class="submit-area">
            <el-button size="mini" type="primary" icon="el-icon-s-promotion" @click="submitCode">提交代码</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import {executeCodingCode} from "../../api/api"
  const DEFAULT_CODE = {
    python: '# 在这里编写你的 Python 代码\nprint("你好，课程平台！")\n',
    cpp: '#include <iostream>\nusing namespace std;\n\nint main() {\n    cout << "你好，课程平台！" << endl;\n    return 0;\n}\n'
  }
  export default {
    props: {
      visible: { type: Boolean, default: false },
      courseType: { type: String, default: "" },
      taskId: { type: String, default: "" }
    },
    data() {
      return {
        code: "",
        output: "",
        running: false,
        scratchRemark: ""
      }
    },
    computed: {
      dialogVisible: {
        get() { return this.visible },
        set(val) { this.$emit("update:visible", val) }
      },
      toolLabel() {
        if (this.courseType == 'scratch') return 'Scratch'
        if (this.courseType == 'python') return 'Python'
        if (this.courseType == 'cpp') return 'C++'
        return ''
      },
      scratchUrl() {
        return this.$store.state.HOST + '/scratch/index.html?v=20260830'
      },
      fileName() {
        return this.courseType == 'python' ? 'main.py' : 'main.cpp'
      }
    },
    methods: {
      resetCode() {
        this.code = DEFAULT_CODE[this.courseType] || ""
        this.output = ""
      },
      insertTab(e) {
        let start = e.target.selectionStart
        let end = e.target.selectionEnd
        this.code = this.code.substring(0, start) + "    " + this.code.substring(end)
        this.$nextTick(() => {
          e.target.selectionStart = e.target.selectionEnd = start + 4
        })
      },
      runCode() {
        if (!this.code.trim()) {
          this.$message({ type: 'warning', message: '请先编写代码' })
          return
        }
        this.running = true
        this.output = ""
        let language = this.courseType == 'python' ? 'python' : 'c++'
        executeCodingCode({ language: language, code: this.code }).then(res => {
          this.running = false
          if (res.code == 1000 && res.data) {
            let result = ""
            if (res.data.stdout) result += res.data.stdout
            if (res.data.stderr) result += (result ? "\n" : "") + "错误信息:\n" + res.data.stderr
            if (!result) result = "程序执行完成，无输出内容（退出码：" + (res.data.exitCode == null ? '-' : res.data.exitCode) + "）"
            this.output = result
          } else {
            this.output = res.message || "代码运行服务暂时不可用，请稍后重试。"
          }
        }).catch(() => {
          this.running = false
          this.output = "代码运行服务暂时不可用，请稍后重试。"
        })
      },
      submitCode() {
        if (!this.code.trim()) {
          this.$message({ type: 'warning', message: '请先编写代码' })
          return
        }
        this.$emit("submit", {
          codingType: this.toolLabel,
          content: this.code,
          remark: ""
        })
      },
      submitScratch() {
        if (!this.scratchRemark.trim()) {
          this.$message({ type: 'warning', message: '请填写作品说明' })
          return
        }
        this.$emit("submit", {
          codingType: "Scratch",
          content: this.scratchRemark,
          remark: "Scratch作品说明"
        })
      },
      openScratchTab() {
        window.open(this.scratchUrl, '_blank')
      },
      handleClose() {
        this.output = ""
        this.scratchRemark = ""
      }
    },
    watch: {
      visible(val) {
        if (val && this.courseType != 'scratch') {
          if (!this.code) {
            this.code = DEFAULT_CODE[this.courseType] || ""
          }
        }
      }
    }
  }
</script>

<style scoped>
  .coding-tool {
    height: 70vh;
  }
  .scratch-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .scratch-iframe {
    flex: 1;
    width: 100%;
    min-height: 400px;
    border: 1px solid #E3F2FD;
    border-radius: 8px;
    background: #FFFFFF;
  }
  .editor-wrap {
    display: flex;
    height: 100%;
    gap: 12px;
  }
  .editor-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    border: 1px solid #E3F2FD;
    border-radius: 8px;
    overflow: hidden;
  }
  .editor-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background: #F5FAFF;
    border-bottom: 1px solid #E3F2FD;
  }
  .editor-file {
    font-size: 13px;
    color: #42A5F5;
    font-family: Consolas, monospace;
  }
  .code-editor {
    flex: 1;
    width: 100%;
    border: none;
    outline: none;
    resize: none;
    padding: 12px;
    font-family: Consolas, 'Courier New', monospace;
    font-size: 14px;
    line-height: 1.6;
    background: #FFFFFF;
    color: #263238;
    tab-size: 4;
  }
  .editor-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    border: 1px solid #E3F2FD;
    border-radius: 8px;
    overflow: hidden;
  }
  .output-title {
    padding: 8px 12px;
    background: #F5FAFF;
    border-bottom: 1px solid #E3F2FD;
    font-size: 13px;
    color: #42A5F5;
  }
  .output-area {
    flex: 1;
    overflow: auto;
    padding: 12px;
    background: #F8FBFF;
  }
  .output-content {
    margin: 0;
    white-space: pre-wrap;
    word-break: break-all;
    font-family: Consolas, 'Courier New', monospace;
    font-size: 13px;
    color: #37474F;
  }
  .output-loading {
    color: #42A5F5;
  }
  .submit-area {
    padding: 10px 12px;
    border-top: 1px solid #E3F2FD;
    background: #FFFFFF;
  }
  .coding-tip {
    margin-top: 10px;
    font-size: 13px;
    color: #42A5F5;
  }
</style>
